import OnboardingCompleted from './OnboardingCompleted';
export default OnboardingCompleted;